var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Watch, Utils, PropertyConverters, Components } from '@pacem/pacem-core';
// namespace Pacem.Components.UI {
const OPEN_CSSCLASS = 'blade-open';
let PacemBladeElement = class PacemBladeElement extends Components.PacemElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'open') {
            this._toggle(val);
        }
    }
    _toggle(open = this.open) {
        const fn = open ? Utils.addClass : Utils.removeClass;
        fn(this, OPEN_CSSCLASS);
        const eventName = open ? 'open' : 'close';
        this.dispatchEvent(new Event(eventName));
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemBladeElement.prototype, "open", void 0);
PacemBladeElement = __decorate([
    CustomElement({ tagName: P + '-blade', shadow: true })
], PacemBladeElement);
export { PacemBladeElement };
//}
